import { createContext } from 'react'

/**
 * Context value for Save State.
 * Provides save status information to child components.
 */
export interface SaveStateContextValue {
  /** Whether a save operation is currently in progress */
  isSaving: boolean
  /** Timestamp of the last successful save */
  lastSaved: Date | null
  /** Whether there are unsaved changes */
  hasUnsavedChanges: boolean
}

export const SaveStateContext = createContext<SaveStateContextValue | null>(null)
